import React from "react";
import { observer } from "mobx-react";
import {
  Switch as SwitchContext,
  Redirect,
  withRouter,
  RouteComponentProps,
} from "react-router-dom";

import AuthStore from "stores/AuthStore";

import Container from "components/Layout/Container";
import Header from "components/Layout/Header";
import PublishButton from "components/PublishButton";

import Pattern from "./Pattern";
import PatternDetails from "./Pattern/PatternDetails";

import { PrivateRoute } from "navigation/Switch";

import ROUTES from "navigation/routes";

type Props = RouteComponentProps & {};

@observer
class ContentPattern extends React.Component<Props> {
  render() {
    return (
      <Container header={<Header controls={<PublishButton />} />}>
        <SwitchContext>
          <PrivateRoute
            path={ROUTES.CONTENT_PATTERNS_PATTERNS}
            component={Pattern}
            allowAccess={AuthStore.isAuthorized}
            redirectTo={ROUTES.CONTENT_PATTERNS_PATTERNS}
            exact
          />
          <PrivateRoute
            path={ROUTES.CONTENT_PATTERNS_PATTERNS_LINK_DETAILS}
            component={PatternDetails}
            allowAccess={AuthStore.isAuthorized}
            redirectTo={ROUTES.CONTENT_PATTERNS_PATTERNS_LINK_DETAILS}
            exact
          />

          <Redirect to={ROUTES.CONTENT_PATTERNS_PATTERNS} />
        </SwitchContext>
      </Container>
    );
  }
}

export default withRouter(ContentPattern);
